import { Modal } from "./Modal.js";
import { DOMHelper } from "../Helpers/DOMHelper.js";
import { FormatHelper } from "../Helpers/FormatHelper.js";
import { DealPageHelper } from "../Helpers/DealPageHelper.js";
import PerfectScrollbar from "perfect-scrollbar";
import { PmDatalayer } from "../Datalayer/PmDatalayer.js";
import { PmDRSDatalayer } from "../Datalayer/PmDRSDatalayer.js";

export class AccessoriesSection {
    constructor(app) {
        this.app = app;
        this.parentId = app.config.elementId;
        this.classAt = "accessories-section";

        this.consents = "";
        this.currentAcc = 0;        
        this.accessories = this.sortAccessories();        
        this.enabled = true;        
    }

    init(containerElement) {        
        containerElement.insertAdjacentHTML('beforeend', this.getHtml());

        var $this = this;
        this.accessoryModal = new Modal(
            this.app,
            "start-accessory-modal",
            this.getModalHtml(),
            null,
            "accessories-section"
        );
        this.accessoryModal.init();

        this.accessoryModal.setHideCallback(() => {
            $this.resetIframe();
        });

        var detail = document.querySelector(".start-accessory-modal .accessory-detail");
        var ps = new PerfectScrollbar(detail, {
            wheelPropagation: false,
            minScrollbarLength: 0,
        });

        this.renderAccessories();        
        this.eventHandlers();
    }

    setBackground(make) {
        let background = make.toLowerCase() == "indian motorcycle" ? "indian-background" : "bmw-background";
        DOMHelper.addClass(this.app.getSelector(".accessory-select-info"), background);
    }

    sortAccessories() {
        if (typeof this.app.config.vehicle.accessories === "object") {
            let accessories = Object.values(this.app.config.vehicle.accessories);
            if (accessories.length > 0) {
                accessories.sort((a, b) =>
                    parseFloat(a.price.toString().replace(",", "")) < parseFloat(b.price.toString().replace(",", ""))
                        ? 1
                        : parseFloat(b.price.toString().replace(",", "")) <
                          parseFloat(a.price.toString().replace(",", ""))
                        ? -1
                        : 0
                );
            }
            return accessories;
        }
        return [];
    }


    renderAccessories() {
        let accessoriesSize = Object.keys(this.accessories).length;
        if (accessoriesSize > 1) {            

            let accSelectedTxt = document.querySelector(this.getSelector(".accessories-selected-txt"));
            accSelectedTxt.textContent = "";
            accSelectedTxt.style.display = "none";
        } else {
            let elems = [".slider-left", ".slider-right"];
            elems.forEach((elem) => {
                let arrow = document.querySelector(this.getSelector(elem));
                if (arrow) arrow.style.display = "none";
            });
        }
        // this.setStepNumbers(true);
        this.printAccessoriesTwoRows(this.accessories);
    }

    printAccessoriesTwoRows(accessories) {
        if (accessories.length > 0) {
            return this.printAccessoriesSingleRow(accessories);
        }
    }

    printAccessoriesSingleRow(accessories) {
        let accessoriesElement = "";
        let parent = this.getSelector(".accessories-images");
        DOMHelper.setInnerHTML(parent, accessoriesElement);
        accessories.forEach((accessory) => {
            if (accessory.enabled == true) {
                let id = accessory.id;
                let image = accessory.src;
                let title = accessory.title;
                let price = accessory.price;
                let sku = accessory.sku;
                let installationPrice = (accessory.installationPrice);
                let installationHTML = "";
                if (installationPrice != 0) {
                    installationHTML =
                        "<div class='item-info'>Installation Price: $" +
                        installationPrice +
                        "</div>";
                }
                var wrapper =
                    "<div id='acc_item_" + id + "' class='slider-item pmdrs-accessory-element d-none'>" +
                    "<img src='" +
                    image +
                    "' class='accessory-img' data-price='" +
                    price +
                    "' data-id='" +
                    id +
                    "' data-title='" +
                    title +
                    "' data-sku='" +
                    sku +
                    "' data-installation='" +
                    parseFloat(installationPrice) +
                    "' alt='image of " +
                    title +
                    "'>" +
                    
                    "<div class='item-name'>" + title + "</div>" +
                    "<div class='item-info'>SKU:" + sku + "</div>" +
                    installationHTML +
                    "<div class='item-info'>MSRP: $" + price + "</div>" +
                    "<div class='item-info disclaimer'>*Price does not contain sales tax</div>" +
                    `<div class='cta-container'>
                        <a data-datalayer="` + title + " - sku: " + sku + `" data-id=`+id+` class='accessory-select-info select-button' href='#'></a>
                        <a data-datalayer="` + title + " - sku: " + sku + `" data-id=`+id+` class='accessory-more-info learnmore-button modal-openbtn'>Learn More</a>
                    </div>` +
                    "</div>";
                accessoriesElement += wrapper;
            }
        });
        DOMHelper.setInnerHTML(parent, accessoriesElement);

        let htmlAccessories = document.querySelectorAll(this.getSelector(".pmdrs-accessory-element"));
        htmlAccessories[this.currentAcc].classList.remove("d-none");
        htmlAccessories[this.currentAcc].classList.add("pmdrs-accessories-active");
        //ADD DOTS
        if (accessories.length > 1) {
            const accessoriesDots = document.querySelector(this.getSelector(".accessories-dots"));
            accessoriesDots.innerHTML = "";
            accessories.forEach((_, index) => {
                const dot = document.createElement("span");
                dot.classList.add("accessories-dot");
                if (index === 0) {
                    dot.classList.add("active");
                }
                accessoriesDots.appendChild(dot);
            });
            const dots = document.querySelectorAll(this.getSelector(".accessories-dot"));
            dots.forEach((dot, index) => {
                DOMHelper.addHandler(dot, "click", () => {
                    // hide current accessory
                    htmlAccessories[this.currentAcc].classList.add("d-none");
                    htmlAccessories[this.currentAcc].classList.remove("pmdrs-accessories-active");
                    // show new accessory
                    htmlAccessories[index].classList.remove("d-none");
                    htmlAccessories[index].classList.add("pmdrs-accessories-active");
                    // update active dot
                    dots[this.currentAcc].classList.remove("active");
                    dot.classList.add("active");
                    // update current index
                    this.currentAcc = index;
                });
            });
        }
    }

    getModalElement(selector){
        return document.querySelector(this.getSelector('.modalacc-item '+selector))
    }

    // vehicle.accessories is keyed by array index ("0","1","2"...), not by each accessory's own
    // .id field (confirmed live: an accessory's real id is a Mongo ObjectId string like
    // "6a8d6a18bfaa6a4e001aa3f6", never a small integer matching its position) — a direct
    // accessories[accessoryId] lookup by that id always misses and returns undefined. The
    // select-button handler never noticed because it only reads DOM data-price attributes for
    // its math and passes the (silently undefined) accessory into a datalayer event; "Learn
    // More" crashes immediately because updateValues() dereferences accessory.id right away.
    // Not a regression from the recent server-side payment-math work — AccessoriesSection.js
    // hasn't changed in months; this id/key mismatch was already there.
    getAccessoryById(accessoryId) {
        return Object.values(this.app.config.vehicle.accessories).find((a) => a.id == accessoryId);
    }

    updateValues(accessory, target) {
        let selectBtnDealPage = target.previousElementSibling;
        console.log(selectBtnDealPage);

        let selectBtn = document.querySelector(this.app.getSelector(".start-accessory-modal .select-button"));
        if (selectBtnDealPage.classList.contains("accessory-select-info")) {
            selectBtn.classList.add("accessory-select-info");
            selectBtn.classList.remove("accessory-selected-info");
        } else {
            selectBtn.classList.remove("accessory-select-info");
            selectBtn.classList.add("accessory-selected-info");
        }
        selectBtn.setAttribute("data-id", accessory.id);
        //adding sku to apply css rules by accessory
        let modal = document.querySelector(this.app.getSelector(".start-accessory-modal"));
        modal.dataset.sku = accessory.sku;

        var titleElement = this.getModalElement(".item-title");
        var nameElement = this.getModalElement(".item-name");
        var descriptionElement = this.getModalElement(".acc-modal-description-value");
        var priceElement = this.getModalElement(".acc-modal-price-value");
        var installationPriceElement = this.getModalElement(".acc-modal-installation-price-value");
        titleElement.innerHTML = accessory.title;
        nameElement.innerHTML = accessory.title;
        descriptionElement.innerHTML = accessory.desc ?? "";
        priceElement.innerHTML = FormatHelper.currencyFormat(accessory.price);
        if (accessory.installationPrice / 100 != 0) {
            installationPriceElement.innerHTML = FormatHelper.currencyFormat(accessory.installationPrice / 100);
            this.getModalElement(".acc-modal-disclaimer-price").style.display = "none";
        } else {
            this.getModalElement(".item-info-installprice").style.display = "none";
            this.getModalElement(".acc-modal-disclaimer-price").style.display = "block";
        }

        var gallery = this.getModalElement("#acc-modal-gallery");
        gallery.innerHTML = "";
        if (accessory.images) {
            accessory.images.forEach((i) => {
                var img = document.createElement("img");
                img.src = i;
                var li = document.createElement("li");
                li.appendChild(img);
                gallery.appendChild(li);
            });
        }

        if (accessory.videos) {
            accessory.videos.forEach((v) => {
                var id = v.split("v=")[1];
                var img = document.createElement("img");
                img.src = "https://img.youtube.com/vi/" + id + "/0.jpg";
                img.dataset.video = id;
                var li = document.createElement("li");
                li.appendChild(img);
                gallery.appendChild(li);
            });
        }
        var $this = this;
        var galleryIframe = this.getModalElement("#acc-modal-gallery-iframe");
        if (accessory.product_type == "package" && accessory.desc == "") {
            let lines = [];
            Object.entries(accessory.accessories).forEach(function (keyValue) {
                let nestedAcc = keyValue[1];
                lines.push(
                    (nestedAcc.packageQty || 1) +
                        // " x " +
                        // nestedAcc.sku +
                        " - " +
                        nestedAcc.name +
                        " $" +
                        (nestedAcc.price)
                );
            });
            let html = lines.join("<br>");
            let accInfo = "<div><p>This package includes these accessories: </p>" + html + "</div>";
            DOMHelper.setInnerHTML(this.getSelector(".accessory-detail"), accInfo);
        } else if (accessory.product_type == "package" && accessory.desc != "") {
            let accInfo = "<div>" + accessory.desc + "</div>";
            DOMHelper.setInnerHTML(this.getSelector(".accessory-detail"), accInfo);
        }

        var galleryImgViewer = this.getModalElement("#acc-modal-gallery-viewer");
        DOMHelper.addHandler(this.getSelector("#acc-modal-gallery img"), "click", function (event) {
            let videoId = event.target.dataset.video;
            var src = event.target.src;
            if (videoId) {
                src = "https://www.youtube.com/embed/" + videoId + "?autoplay=1";
                galleryIframe.style.display = "block";
                galleryImgViewer.style.display = "none";
                galleryIframe.src = src;
            } else {
                galleryIframe.style.display = "none";
                galleryImgViewer.style.display = "block";
                galleryImgViewer.src = src;
                $this.resetIframe();
            }
        });

        //FIRE CLICK FIRST IMAGE
        var firstImg = this.getModalElement("#acc-modal-gallery img");
        if (firstImg) {
            DOMHelper.triggerEvent(firstImg, "click");
        }

        //FIRE DETAIL SCROLL EVENT
        DOMHelper.querySelectorAction(this.getSelector(".accessory-detail"), (item) => {
            item.scrollTop = 1;
        });
    }

    resetIframe() {
        var galleryIframe = document.querySelector(this.getSelector("#acc-modal-gallery-iframe"));
        galleryIframe.src = "";
        this.app.pmDRSDatalayer.videoInteractionEvent(PmDatalayer.ACCESSORIES_INFO_MODAL_SECTION, 'close');
    }

    getHtml() {
        return `<div class="trigger-element" data-index="1"></div>
<div class="accessories-section deal-page-section" id="accessories-section">
    <div class="accessories-title">Extras</div>
    <div class="accessories-subtitle">Accessorize, add Extended Warranties or Service plans and roll them into your payment.</div>
    <div class="accessories-slider">
        <a class="slider-left">‹</a><a class="slider-right">›</a>
<!--         <div class="slider-item">
            <img src="http://bmwdrs.dev.pixelmotiondemo.com/wp-content/uploads/2024/01/accessories-img.jpg" alt="image of Vario Case Luggage System" />
            <div class="item-name">Vario Case Luggage System</div>
            <div class="item-info">SKU: P77419899409</div>
            <div class="item-info">Installation Price: $125.00</div>
            <div class="item-info">MSRP: $1568.00</div>
            <div class="item-info disclaimer">*Price does not contain sales tax.</div>
            <div class="cta-container"><a class="select-button" href="#">Select</a><a class="learnmore-button modal-openbtn" data-modal="modalAccessories">Learn More</a></div>
        </div> -->
        <div class="accessories-images">
        </div>  
    </div>

    <div class="d-flex accessory-parent">                    
        <div class="accessories-selected">
            <p class="accessories-selected-txt"></p>
        </div>
        <div class="accessories-dots"></div> 
    </div>   
    

</div>`;
    }

    getModalHtml() {
        return `<div class="start-accessory-modal">
    <div class="modalacc-item">
        <div class="item-title">Vario Case Luggage System</div>

        <div>
            <img id="acc-modal-gallery-viewer">
            <iframe id="acc-modal-gallery-iframe" allowfullscreen='true' allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture">
                
            </iframe>
            <div class="accessory-detail"></div>
            <ul id="acc-modal-gallery"> 
            </ul>
        </div>

        <div class="item-name">Vario Case Luggage System</div>        
        <div class="acc-modal-description-value"></div>    
        <div class="item-info-installprice">Installation Price: <span class="acc-modal-installation-price-value"></span></div>
        <div class="item-info-msrp">MSRP: <span class="acc-modal-price-value"></span></div>
        <p class="acc-modal-disclaimer-price"><stong><span>*This price does not include Installation cost</span></stong></p>
        <br>
        <a href="https://accessories.dev.pixelmotiondemo.com/api/documents/motorrad_esc_brochure" target="_blank" class="acc-pdf-link motorrad-esc-brochure-link">Motorrad ESC Brochure</a>
        <a href="https://accessories.dev.pixelmotiondemo.com/api/documents/bmw_motorrad_gap" target="_blank" class="acc-pdf-link motorrad-gap-link">BMW Motorrad GAP</a>
        <a href="https://accessories.dev.pixelmotiondemo.com/api/documents/bmw_motorrad_tire_and_wheel_protection" target="_blank" class="acc-pdf-link motorrad-tire-protection-link">BMW Motorrad Tire & Wheel Protection</a>
        <div class="cta-container"><a class="select-button accessory-select-info" href="#"></a></div>
    </div>    
</div>
`;
    }

    getSelector(selector) {
        return this.app.getSelector("." + this.classAt + " " + selector);
    }

    getSelectorFromDealPage(selector) {
        return this.app.dealPage.getSelector(selector);
    }

    /**
     * to disable the whole section     
     */
    disable(){
        this.enabled = false;        
        DOMHelper.addClass(this.getSelector('.cta-container a'), 'disabled');
        DOMHelper.addClass(this.getSelector(''), 'disabled-section');
    }

    /**
     * to enable the whole section     
     */
    enable(){
        this.enabled = true;        
        DOMHelper.removeClass(this.getSelector('.cta-container a'), 'disabled');
        DOMHelper.removeClass(this.getSelector(''), 'disabled-section');
    }

    getCurrentDisplayedAccessory(){
        var accessory = this.accessories[this.currentAcc];
        return accessory;
    }

    eventHandlers() {
        var $this = this;
        // DOMHelper.addHandler(this.getSelector(".accessory-select-info"), "click", (event) => {
        //     let target = event.target;
        //     let id = target.getAttribute("data-id");
        //     console.log(id);
        //     target.classList.toggle("accessory-select-info");
        //     target.classList.toggle("accessory-selected-info");

        //     let span = document.querySelector(this.getSelectorFromDealPage("span[data-id='" + id + "']"));
        //     if (span) span.click();
        // });        
        
        let nxtBtn = document.querySelector(this.getSelector(".slider-right"));
        let prevBtn = document.querySelector(this.getSelector(".slider-left"));

        if (nxtBtn != undefined) {
            let nxtBtnEvent = function () {
                let htmlAccessories = document.querySelectorAll($this.getSelector(".pmdrs-accessory-element"));
                htmlAccessories[$this.currentAcc].classList.remove("pmdrs-accessories-active");
                htmlAccessories[$this.currentAcc].classList.add("d-none");

                if ($this.currentAcc >= htmlAccessories.length - 1) {
                    $this.currentAcc = 0;
                } else {
                    $this.currentAcc += 1;
                }
                htmlAccessories[$this.currentAcc].classList.add("pmdrs-accessories-active");
                htmlAccessories[$this.currentAcc].classList.remove("d-none");
                const dots = document.querySelectorAll($this.getSelector(".accessories-dot"));
                dots.forEach((dot) => {
                    dot.classList.remove("active");
                });
                dots[$this.currentAcc].classList.add("active");
            };

            nxtBtn.addEventListener("click", nxtBtnEvent);
        }

        if (prevBtn != undefined) {
            let prevBtnEvent = function () {
                let htmlAccessories = document.querySelectorAll($this.getSelector(".pmdrs-accessory-element"));
                htmlAccessories[$this.currentAcc].classList.remove("pmdrs-accessories-active");
                htmlAccessories[$this.currentAcc].classList.add("d-none");
                if ($this.currentAcc != 0) {
                    $this.currentAcc -= 1;
                }
                console.log($this.currentAcc);
                htmlAccessories[$this.currentAcc].classList.remove("d-none");
                htmlAccessories[$this.currentAcc].classList.add("pmdrs-accessories-active");
                const dots = document.querySelectorAll($this.getSelector(".accessories-dot"));
                dots.forEach((dot) => {
                    dot.classList.remove("active");
                });
                dots[$this.currentAcc].classList.add("active");
            };

            prevBtn.addEventListener("click", prevBtnEvent);
        }

        DOMHelper.addHandler(this.getSelector(".pmdrs-accessory-element .select-button"), "click", (event) => {
            event.preventDefault()
            if(!$this.enabled) return;

            let parent = "";
            let target = event.target;

            // Pre-toggle state, checked directly on the node before it's flipped below - this is
            // what action the user actually took: clicking a button that still reads "select" is
            // a select action, clicking one that already reads "selected" is an unselect action.
            // This is the only reliable source of truth here, since the click bindings in
            // PmDRSDatalayer are attached once at page load and never re-evaluate this node's
            // classes afterward (see PmDRSDatalayer.js addHandlers()).
            var wasSelected = DOMHelper.hasClass(target, "accessory-selected-info");

            target.classList.toggle("accessory-select-info");
            target.classList.toggle("accessory-selected-info");

            parent = target.parentNode.parentNode;

            parent.classList.toggle("accessory-selected");
            $this.app.dealPage.updatePriceByAccessories();

            var accessory = $this.getAccessoryById(target.dataset.id);

            //DATALAYER
            if(!wasSelected){
                $this.app.shiftDatalayer.fireEvent('drAddToCart', {accessory});
            }

            var elementLabel = wasSelected ? "accessory unselect button" : "accessory select button";
            $this.app.pmDRSDatalayer.generalClickEvent(PmDRSDatalayer.ACCESSORIES_SECTION, elementLabel, target);
        });

        DOMHelper.addHandler(this.getSelector(".accessory-more-info"), "click", (event) => {
            event.preventDefault()
            if(!$this.enabled) return;
            
            var data = event.target.dataset;
            let target = event.target;
            var accessory = $this.getAccessoryById(data.id);
            $this.updateValues(accessory, target);
            $this.accessoryModal.show();
            event.stopPropagation();
        });
        
        DOMHelper.addHandler(this.app.getSelector(".start-accessory-modal .select-button"), 'click', (event)=> {
            event.preventDefault()
            var data = event.target.dataset;
            var btnSelector = $this.app.getSelector("#acc_item_" + data.id + " .select-button");
            var accItemSelectBtn = document.querySelector(btnSelector);
            DOMHelper.triggerEvent(accItemSelectBtn, 'click');
            event.target.classList.toggle("accessory-select-info");
            event.target.classList.toggle("accessory-selected-info");
            this.accessoryModal.hide();
        });

        // DOMHelper.addHandler(this.app.getSelector('.acc-pdf-link'), 'click', function(e) {
        //     e.preventDefault(); // Prevent the default link behavior
        //     var fileName = this.href.substring(this.href.lastIndexOf('/') + 1);

        //     fetch(this.href, {
        //         method: 'GET'
        //     })
        //     .then(response => response.blob()) // Get the file as a Blob
        //     .then(blob => {
        //         const url = window.URL.createObjectURL(blob); // Create a URL for the Blob
        //         const a = document.createElement('a'); // Create a temporary link element
        //         a.href = url;
        //         a.download = fileName + '.pdf'; // Set the file name
        //         document.body.appendChild(a); // Append the link to the document
        //         a.click(); // Programmatically click the link to trigger the download
        //         a.remove(); // Remove the link after downloading
        //     })
        //     .catch(error => {
        //         console.error('Error downloading the file:', error);
        //     });
        // });
        
    }
}
